import BannerImage from '@/entity/Banner/BannerImage';

export default class Banner {
  constructor() {
    this.name = undefined;
    this.images = undefined;
    this.themeId = undefined;
    this.userTypeId = undefined;
  }

  loadData(payload) {
    this.name = payload.name;
    this.themeId = payload.theme.id;
    this.userTypeId = payload.userType.id;

    if (payload.images) {
      this.images = payload.images.map((image) => new BannerImage(image));
    }
  }
}
